import { z } from 'zod';

import { type ValidationMessageSet } from '../../form-validations';
import { getCaptchaTokenSchema } from '../../schemas/captcha-token-schema';
import { getEmailSchema } from '../../schemas/email-schema';

type Messages = {
  emailValidationMessages: ValidationMessageSet;
  submitError: string;
};

// Validation shared between client form & API payload
export const getBaseSchema = (messages?: Messages) =>
  getEmailSchema(messages?.emailValidationMessages);

// Validation for client form only
export const getNurturingSchema = (messages: Messages) =>
  getBaseSchema().merge(
    getCaptchaTokenSchema({ requiredMessage: messages.submitError })
  );

// Validation for client form only
export const getNurturingNewsletterSchema = (messages: Messages) =>
  z
    .object({
      newsletter: z.boolean(),
    })
    .merge(getNurturingSchema(messages))
    .required();

type BlogAdMessages = Messages & {
  legalValidationMessages: Pick<ValidationMessageSet, 'requiredMessage'>;
};

// Validation for client form only
export const getBlogAdSchema = (messages: BlogAdMessages) =>
  z
    .object({
      legal: z.literal<boolean>(true, {
        errorMap: () => ({
          message: messages.legalValidationMessages.requiredMessage,
        }),
      }),
    })
    .merge(getNurturingSchema(messages))
    .required();
